// modules/swiper.js
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

// Espere o DOM carregar
// Inicialização do Swiper
document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".banner-home-swiper", {
        // Optional parameters
        direction: "horizontal",
        loop: true,
        slidesPerView: 1, // Exibe 1 slide por vez
        spaceBetween: 0, // Sem espaçamento entre slides

        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: true, // Geralmente oculta a barra de rolagem em banners
        },

        // Autoplay (opcional)
        autoplay: false,
    });
});
